import { BaseRequest } from 'src/app/tools/models/dtos/base-request';import { Role } from '../../entities/master-data/role-entity';


export class RoleRequest extends BaseRequest {
  role : Role;
  constructor(userInfo){
    super(userInfo);
    this.role = new Role();
  }
}